<script setup lang="ts">
import { RouterView, useRouter, useRoute } from 'vue-router'
import BaseToast from '@/components/shared/BaseToast.vue'
import { useIdle, useIntervalFn } from '@vueuse/core'
import { useAuthStore } from '@/stores/authStore'
import { useNotificationStore } from '@/stores/notificationStore'
import { onUnmounted, watch } from 'vue'

const authStore = useAuthStore()
const notificationStore = useNotificationStore()
const router = useRouter()
const route = useRoute()
const { idle } = useIdle(30 * 60 * 1000) // 30 minutes

watch(
    () => authStore.user?.user.id,
    (userId) => {
        if (userId) {
            notificationStore.fetchLatest()
            notificationStore.subscribe()
        } else {
            notificationStore.unsubscribe()
        }
    },
    { immediate: true },
)

// Fallback for when the websocket is unavailable; realtime events refetch too.
useIntervalFn(() => {
    if (authStore.user) {
        notificationStore.fetchLatest()
    }
}, 60000)

onUnmounted(() => notificationStore.unsubscribe())

watch(idle, async (idleValue) => {
    if (idleValue && route.path !== '/') {
        await authStore.logout()

        router.push('/')
    }
})
</script>

<template>
    <RouterView v-slot="{ Component }">
        <BaseToast />
        <Transition name="fade" mode="out-in">
            <component :is="Component" />
        </Transition>
    </RouterView>
</template>

<style lang="postcss"></style>
